






































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UpdateActivityInfo, QueryBrochureById, CreateBrochure, UpdateBrochure } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import constan from '@/utils/constant'

import axios from 'axios'
import mavonEditor from 'mavon-editor'
import Conf from '@/config/config'
import API from '@/api/api'
const md = mavonEditor.mavonEditor

@Component({
  components: { VImageUpload, md },
})
export default class UpdateActivityInfoDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private isDesc!: boolean
  private show = false
  private activeCode = ''
  private mdFile: any = {}
  private data: any = {}
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    activityTheme: [this.requiredRule],
    activityStartTime: [this.requiredRule],
  }
  private activityStatus = constan.ActivityInfoStatus

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {}
  }
  public open(data: any) {
    this.show = true
    this.data = data
    if (this.data.coverImg) {
      this.data.coverImgList = this.data.coverImg.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.coverImgList = []
    }
    this.loadMdFile()
  }

  private async loadMdFile() {
    if (this.data.fileId) {
      const result = await QueryBrochureById({ id: this.data.fileId })
      this.mdFile = result
    }
  }

  private mdFileChange(value: any, render: any) {
    this.mdFile.html = render
  }

  private async mdFileUpload(pos: any, file: any) {
    const fileUploadUrl = Conf.API_HOST + API.fileUpload
    var formdata = new FormData()
    formdata.append('file', file)
    axios({
      url: fileUploadUrl,
      method: 'post',
      data: formdata,
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((url) => {
      // 第二步.将返回的url替换到文本原位置![...](0) -> ![...](url)
      /**
       * $vm 指为mavonEditor实例，可以通过如下两种方式获取
       * 1. 通过引入对象获取: `import {mavonEditor} from ...` 等方式引入后，`$vm`为`mavonEditor`
       * 2. 通过$refs获取: html声明ref : `<mavon-editor ref=md ></mavon-editor>，`$vm`为 `this.$refs.md`
       */
      const mdref = this.$refs.md as any
      mdref.$img2Url(pos, url.data.data.fileUrl)
    })
  }

  public async save() {
    if (this.isDesc) {
      this.close()
      return
    }
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }

      // 保存md文件
      if (this.mdFile.id) {
        this.mdFile.name = this.data.activityTheme
        this.mdFile.pageTitle = this.data.activityTheme
        const mdFileId = await CreateBrochure(this.mdFile)
        this.data.fileId = mdFileId
      } else {
        await UpdateBrochure(this.mdFile)
      }

      this.data.coverImg = this.data.coverImgList.map((e: any) => e.url).join(',')
      await UpdateActivityInfo(this.data)
      Message.success('保存')
      this.close()
    })
  }
}
